export const DEFAULT_PROSPECTS_PER_COMPANY = 5;
export const DEFAULT_COMPANIES_PER_PAGE = 15;
export const BLOCKLIST_LIMIT = 5000;

export const SocketEvents = {
    prospect: {},
    company: {},
    user: {},
};

export const LocalStorageKeys = {
    AUTHENTICATE_AS_USER: 'x-authenticate-as-user',
    INITIAL_LOAD: 'initial_load',
    REDIRECT_TO_URL: 'redirect_to_url',
};

export const googleWorkspaceOAuthId = '733572450029-a2050rev93ddkc6b324a9uigcnj090bm.apps.googleusercontent.com';
